export enum LANGUAGES {
  en = 'en',
  de = 'de',
  es = 'es',
  fr = 'fr',
  it = 'it',
}
